import React, { useEffect, useState, useRef } from "react";
import Cart from "../utils/Cart";
import Backend from "../utils/Backend";
import Currency from "../utils/Currency";
import ProductStore from "../utils/ProductStore";

const InsureshipWidget = ({ cart, updateCart, insureShipDefChecked }) => {
    const [insureShipProduct, setInsureShipProduct] = useState(null);
    const [checked, setChecked] = useState(false);
    const [bannerLoaded, setBannerLoaded] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const sessionCheckedValue = sessionStorage.getItem("cc-insure-ship-default-checked");
    const insureShipProductId = window?.CURRENT_CAMPAIGN?.insureShipProductId;
    const insureShipId = window?.CURRENT_CAMPAIGN?.insureShipId;
    const cartItemsCount = cart?.items?.length || 0;
    const cartItemsCountWithoutInsureShipProduct =  cart?.items?.filter((o) => o?.product?.campaignProductId != insureShipProductId)?.length || 0;
    const isCartShippable = cart?.items?.some((o) => o?.product?.cycle1_isShippable && o?.product?.campaignProductId != insureShipProductId);

    const updateInsureShipWidgetClick = async (value) => {
        if (!insureShipProduct) return;
        let data = null;
        if (value && (sessionCheckedValue ? sessionCheckedValue === "true" : true)) {
            const item = cart?.items?.find((o) => o.ccCartKey == insureShipProductId);
            data = !item && await Cart.add(insureShipProduct, null, [], 1, null);
        } else {
            data = await Cart.remove(insureShipProduct, null, [], 1, null);
        }
        data && updateCart && updateCart(data);
    };

    const setCheckedWrapper = (value) => {
        setChecked(value && (sessionCheckedValue ? sessionCheckedValue === "true" : true));
    }

    useEffect(() => {
        updateInsureShipWidgetClick(checked);
    }, [checked]);

    useEffect(() => {
        if (insureShipProductId && insureShipId && insureShipProduct) {
            const defChecked = sessionCheckedValue ? sessionCheckedValue === "true" : (!insureShipDefChecked ? true : false);
            setChecked(defChecked);
        }
    }, [insureShipProductId, insureShipId, insureShipProduct]);

    useEffect(() => {
        if (insureShipProductId) {
            const product = ProductStore.products?.find((o) => o.campaignProductId === insureShipProductId);
            if (product) {
                setInsureShipProduct(product);
                return;
            }
            Backend.getProducts(insureShipProductId).then((products) => {
                let insureShipProduct = products?.[0];
                if (insureShipProduct) {
                    setInsureShipProduct(insureShipProduct);
                }
            }).catch((_) => {});
        }
    }, [insureShipProductId]);

    useEffect(() => {
        if (cartItemsCountWithoutInsureShipProduct && !isCartShippable) {
            setCheckedWrapper(false);
        } else {
            setCheckedWrapper(true);
            updateInsureShipWidgetClick(true);
        }
    }, [isCartShippable, cartItemsCountWithoutInsureShipProduct, insureShipProduct]);

    useEffect(() => {
        if (insureShipProduct && !cartItemsCountWithoutInsureShipProduct) {
            setCheckedWrapper(false);
            updateInsureShipWidgetClick(false);
        }
    }, [insureShipProduct, cartItemsCountWithoutInsureShipProduct]);

    const handleInsureShipWidgetClick = (event) => {
        if (!isCartShippable && (cartItemsCount === 1 && cart?.items?.[0]?.campaignProductId == insureShipProductId ? false : true)) return;
        setChecked(event.target.checked);
        sessionStorage.setItem("cc-insure-ship-default-checked", event.target.checked);
    };
    
    const hideWidget = !(insureShipProductId && insureShipId && insureShipProduct) || !cartItemsCountWithoutInsureShipProduct || !isCartShippable;

    return (
        <>
            <div class={`storefront-insure-ship-widget-container ${hideWidget ? " d-none" : ""}`}>
                {!bannerLoaded && showBanner && <div className="storefront-insure-ship-widget-banner">
                    <img
                        width="285"
                        height="325"
                        src="https://www.insureship.com/images/insureship_decline_banner.png"
                        border="0"
                        alt={"Insureship decline banner"}
                        onError={() => {
                            setBannerLoaded(true);
                        }}
                    />
                </div>}
                <div class="storefront-insure-ship-widget">
                    <div class="storefront-insure-ship-widget-top-row">
                        <div class="storefront-insure-ship-widget-label">
                            <svg viewBox="0 0 24 24">
                            <path d="M12 2L4 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-3zm0 17.3c-2.5-1-6-4.65-6-9.3V6.25L12 4l6 2.25V10c0 4.65-3.5 8.3-6 9.3z"/>
                            </svg>
                            Shipping Protection
                        </div>
                        <div>
                            <label class="storefront-insure-ship-widget-switch"
                                onMouseOver={() => {
                                    setShowBanner(true);
                                }}
                                onMouseLeave={() => {
                                    setShowBanner(false);
                                }}
                            >
                                <input
                                    name="storefrontInsureShipProduct"
                                    type="checkbox"
                                    checked={checked}
                                    class="storefront-insure-ship-checkbox"
                                    value={insureShipProductId}
                                    onChange={handleInsureShipWidgetClick}
                                />
                                <span class="storefront-insure-ship-widget-slider" id="insureship_decline_hover"></span>
                            </label>
                        </div>
                    </div>
                    <div class="storefront-insure-ship-widget-description">
                        Complete coverage for loss, damage, or theft for only <span class="storefront-insure-ship-widget-price-value">{Currency.toFormat(insureShipProduct?.cycle1_price || 0)}</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InsureshipWidget;
